import { useMemo } from 'react';
import { dspxDiffDays } from '../../../helpers/dspx-utils';
import moment from 'moment';

const useAttributiesFilter = (
  requests = [],
  valuesAttributes = [],
  dayExcess
) => {
  const filteredRequests = useMemo(() => {
    if (valuesAttributes.length === 0) return requests;

    return requests?.filter((request) => {
      const dayExpired = request.doneDateTime
        ? dspxDiffDays(request.doneDateTime, request.executeDateTime)
        : dspxDiffDays(0, request.executeDateTime);

      const hasExpired =
        !isNaN(dayExpired) &&
        request.statusId !== 4 &&
        Number(dayExpired) > 0 &&
        !request.doneDateTime;

      const hasDedline =
        dspxDiffDays(request.executeDateTime, moment().toString()) >= 0 &&
        dspxDiffDays(request.executeDateTime, moment().toString()) <= 7 &&
        !request.doneDateTime &&
        (request.statusId === 1 || request.statusId === 2);

      const dayDedline = hasDedline
        ? dspxDiffDays(request.executeDateTime, moment().toString())
        : null;

      const hasExcess =
        !!dayExcess &&
        (request?.statusId === 1 || request?.statusId === 2) &&
        moment(request.executeDateTime).isAfter(moment(dayExcess), 'day');

      return valuesAttributes?.some((filterValue) => {
        switch (filterValue) {
          case 1:
            return !!dayDedline;
          case 2:
            return !!hasExpired;
          case 3:
            return !!hasExcess;
          default:
            return true;
        }
      });
    });
  }, [JSON.stringify(requests), valuesAttributes.length, dayExcess]);

  return filteredRequests;
};

export default useAttributiesFilter;
